// =========================
// PERFORMANCE REWRITE (GET - Jun 2026)
// Vanilla JS — jQuery no longer required for this file.
// jQuery is still loaded only because slick-carousel needs it (2 calls at bottom).
// =========================

(function () {
  "use strict";

  // ---- small helpers (replace jQuery utility calls) ----
  function on(eventType, selector, handler) {
    document.addEventListener(eventType, function (e) {
      const target = e.target.closest(selector);
      if (target) handler.call(target, e);
    });
  }

  function offsetTop(el) {
    return el.getBoundingClientRect().top + window.scrollY;
  }

  function smoothScrollTo(top) {
    window.scrollTo({ top: top, behavior: "smooth" });
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  // =========================
  // ATC Product Grid SECTION
  // =========================
  on("click", ".addtocart-button button", function (e) {
    e.preventDefault();

    const btn = this;
    if (btn.classList.contains("loading")) return;

    const text = btn.querySelector("span");
    const loader = btn.querySelector(".loader-sec");
    const cardWrapper = btn.closest(".card-wrapper");
    const btnAdd = cardWrapper
      ? cardWrapper.querySelector(".card-information__button add-to-cart")
      : null;

    btn.classList.add("loading");
    if (text) text.textContent = "";
    if (loader) loader.style.display = "";

    if (btnAdd) btnAdd.click();

    setTimeout(function () {
      if (text) text.textContent = "+ Add";
      if (loader) loader.style.display = "none";
      btn.classList.remove("loading");
    }, 1500);
  });

  // =========================
  // BUTTON SECTION SCROLL (click to jump)
  // =========================
  on("click", ".buttonsection-main button", function () {
    const targetId = this.dataset.value;
    const targetEl = targetId ? document.querySelector(targetId) : null;
    if (targetEl) smoothScrollTo(offsetTop(targetEl) - 120);
  });

  // =========================
  // ACTIVE BUTTON ON SCROLL + FIXED BUTTON SECTION
  // Combined into ONE rAF-throttled scroll listener.
  // Section offsets are cached on load/resize, not recalculated every scroll tick.
  // =========================
  let sectionCache = [];
  let firstSectionTop = null;
  const buttonSectionEl = document.querySelector(".buttonsection-main");

  function cacheSectionOffsets() {
    const sections = document.querySelectorAll(".collectiongrid-mainsection");
    sectionCache = Array.prototype.map.call(sections, function (sec) {
      return {
        id: sec.id,
        top: offsetTop(sec) - 150,
        bottom: offsetTop(sec) - 150 + sec.offsetHeight,
      };
    });
    firstSectionTop = sections.length ? offsetTop(sections[0]) : null;
  }

  let scrollTicking = false;
  function handleScroll() {
    const scrollPos = window.scrollY;

    for (let i = 0; i < sectionCache.length; i++) {
      const s = sectionCache[i];
      if (scrollPos >= s.top && scrollPos < s.bottom) {
        document
          .querySelectorAll(".buttonsection-main button.active")
          .forEach(function (b) { b.classList.remove("active"); });
        const activeBtn = document.querySelector(
          '.buttonsection-main button[data-value="#' + s.id + '"]'
        );
        if (activeBtn) activeBtn.classList.add("active");
        break;
      }
    }

    if (buttonSectionEl && firstSectionTop !== null) {
      if (scrollPos >= firstSectionTop - 100) {
        buttonSectionEl.classList.add("fixed");
      } else {
        buttonSectionEl.classList.remove("fixed");
      }
    }

    scrollTicking = false;
  }

  window.addEventListener(
    "scroll",
    function () {
      if (!scrollTicking) {
        requestAnimationFrame(handleScroll);
        scrollTicking = true;
      }
    },
    { passive: true }
  );

  window.addEventListener("resize", cacheSectionOffsets);
  window.addEventListener("load", cacheSectionOffsets);
  ready(cacheSectionOffsets);

  // =========================
  // COUNTDOWN TIMER
  // =========================
  ready(function () {
    const timerEl = document.getElementById("sale-timer");
    if (!timerEl) return;

    let timerInterval;

    function pad(n) {
        return String(n).padStart(2, "0");
    }

    function getNextMidnight() {
        const now = new Date();
        const midnight = new Date(now);

        // Next day 12:00 AM
        midnight.setDate(now.getDate() + 1);
        midnight.setHours(0, 0, 0, 0);

        return midnight.getTime();
    }

    let target = getNextMidnight();

    function updateTimer() {
        const now = Date.now();

        // Agar 12 baje cross ho gaye to next midnight set kar do
        if (now >= target) {
            target = getNextMidnight();
        }

        const distance = target - now;

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        const daysEl = document.getElementById("days");
        const hoursEl = document.getElementById("hours");
        const minutesEl = document.getElementById("minutes");
        const secondsEl = document.getElementById("seconds");

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    updateTimer();
    timerInterval = setInterval(updateTimer, 1000);
});

  // =========================
  // SEARCH TOGGLE
  // =========================
  on("click", ".searchicon-sec img", function () {
    const el = document.querySelector(".custom_predictive");
    if (el) el.classList.toggle("active");
  });

  on("click", ".dropsection-main", function () {
    this.classList.toggle("active");
  });

  // =========================
  // POPUP OPEN / CLOSE
  // =========================
  on("click", ".dock__item.dock__item--primary", function () {
    const popup = document.querySelector(".brandpopup-image");
    if (popup) popup.classList.add("active");
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
  });

  on("click", ".brandpopup-heading img", function () {
    const popup = document.querySelector(".brandpopup-image");
    if (popup) popup.classList.remove("active");
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
  });

  // =========================
  // STICKY ADD TO CART
  // =========================
  on("click", ".addtocart-sticky button", function (e) {
    e.preventDefault();

    const btn = this;
    const text = btn.querySelector("span");
    const loader = btn.querySelector(".loader-sec");

    const variantSelects = document.querySelector("variant-selects");
    if (variantSelects) {
      smoothScrollTo(offsetTop(variantSelects) - 120);
    }

    btn.classList.add("loading");
    if (text) text.textContent = "";
    if (loader) loader.style.display = "";

    const submitBtn = document.querySelector(".product-form__submit");
    if (submitBtn) submitBtn.click();

    setTimeout(function () {
      if (text) text.textContent = "Add to Cart";
      if (loader) loader.style.display = "none";
      btn.classList.remove("loading");
    }, 1500);
  });

  // =========================
  // VARIANT PRICE UPDATE
  // =========================
  function updateVariantPrice() {
    const checkedRadios = document.querySelectorAll(
      'variant-selects input[type="radio"]:checked'
    );
    const selectedValues = Array.prototype.map
      .call(checkedRadios, function (r) { return (r.value || "").trim(); })
      .filter(Boolean);

    const finalVariant = selectedValues.join(" / ");
    const variantOptions = document.querySelectorAll("#product-variants option");

    variantOptions.forEach(function (opt) {
      let optionTitle = opt.getAttribute("data-title");
      if (!optionTitle) return;
      optionTitle = optionTitle.trim();

      if (optionTitle === finalVariant) {
        const price = opt.getAttribute("data-price") || "";
        const compare = opt.getAttribute("data-compare") || "";
        const discount = opt.getAttribute("data-discount") || "";

        const priceSec = document.querySelector(".pricesec");
        const compareSec = document.querySelector(".compareprice-sticky");
        const discountSec = document.querySelector(".discountprice-sec");

        if (priceSec) priceSec.innerHTML = price;

        if (compare !== "" && compare !== price) {
          if (priceSec) priceSec.classList.remove("widthincrease");
          if (compareSec) {
            compareSec.innerHTML = compare;
            compareSec.style.display = "";
          }
          if (discountSec) {
            discountSec.innerHTML = discount;
            discountSec.style.display = "";
          }
        } else {
          if (priceSec) priceSec.classList.add("widthincrease");
          if (compareSec) compareSec.style.display = "none";
          if (discountSec) discountSec.style.display = "none";
        }

        const productVariants = document.getElementById("product-variants");
        if (productVariants) productVariants.value = opt.value;
      }
    });
  }

  // =========================
  // VARIANT CHANGE
  // =========================
  on("change", 'variant-selects input[type="radio"]', function () {
    updateVariantPrice();
  });

  window.addEventListener("load", updateVariantPrice);

  // =========================
  // Variant Function Product Grid
  // =========================
  ready(function () {
    function getSelectedVariant(parentSection) {
      const selectedOptions = [];

      parentSection.querySelectorAll(".variantbox-section").forEach(function (box) {
        const activeBtn = box.querySelector("button.active");
        const selectedValue = activeBtn ? activeBtn.dataset.value : null;
        if (selectedValue) selectedOptions.push(selectedValue.trim());
      });

      const selectedTitle = selectedOptions.join(" / ");

      const productMain = parentSection.closest(".product-main");
      if (!productMain) return;

      const variantSelect = productMain.querySelector(".product-variants");
      if (!variantSelect) return;

      const options = variantSelect.querySelectorAll("option");

      options.forEach(function (opt) {
        const optionTitle = (opt.getAttribute("data-title") || "").trim();

        if (optionTitle === selectedTitle) {
          const popup = parentSection.querySelector(".addtocart-popup");
          if (popup) popup.setAttribute("data-variant-id", opt.value);
        }
      });

      if (options.length === 1) {
        const popup = parentSection.querySelector(".addtocart-popup");
        if (popup) popup.setAttribute("data-variant-id", options[0].value);
      }
    }

    on("click", ".variantbox-section button", function () {
      const parentSection = this.closest(".variant-section");
      if (!parentSection) return;

      const siblingBtns = this
        .closest(".variantbox-section")
        .querySelectorAll("button");
      siblingBtns.forEach(function (b) { b.classList.remove("active"); });

      this.classList.add("active");

      getSelectedVariant(parentSection);
    });
  });

  // =========================
  // ADD TO CART (popup variant)
  // =========================
  on("click", ".addtocart-popup", function (e) {
    e.preventDefault();

    const btn = this;
    if (btn.classList.contains("loading")) return;

    const text = btn.querySelector("span");
    const loader = btn.querySelector(".loader-sec");
    const cardWrapper = btn.closest(".card-wrapper");
    const btnAdd = cardWrapper
      ? cardWrapper.querySelector(".card-information__button add-to-cart")
      : null;

    btn.classList.add("loading");
    if (text) text.textContent = "";
    if (loader) loader.style.display = "";

    if (btnAdd) btnAdd.click();
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("cart:open"));

    setTimeout(function () {
      if (text) text.textContent = "Add to Cart";
      if (loader) loader.style.display = "none";
      btn.classList.remove("loading");
    }, 1500);
  });

  // =========================
  // SHOP POPUP TOGGLE
  // =========================
  on("click", ".shoppopup-sectionnew", function () {
    const cat = document.querySelector(".category-sectionmain");
    if (cat) {
      cat.style.display = cat.style.display === "none" ? "" : "none";
    }
    document
      .querySelectorAll(".shoppopup-sectionnew")
      .forEach(function (el) { el.classList.toggle("active"); });
    document.body.classList.toggle("scrollhidesec");
    document.documentElement.classList.toggle("scrollhidesec");
  });

  // =========================
  // SLICK SLIDERS — jQuery still required here (slick-carousel dependency)
  // =========================
  ready(function () {
    if (typeof window.jQuery === "undefined" || !window.jQuery.fn.slick) return;
    const $ = window.jQuery;

    // $(".usplist-slider").slick({
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   vertical: true,
    //   autoplay: false,
    //   arrows: false,
    //   dots: false,
    //   infinite: true,
    //   autoplaySpeed: 3000,
    // });

    $(".stickyslider-bar").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      vertical: true,
      autoplay: true,
      arrows: false,
      dots: false,
      infinite: true,
      autoplaySpeed: 3000,
    });

    if (window.innerWidth > 768) {
      $(".product-grid.grid .grid__item .card-wrapper")
        .on("mouseenter", function () {
          const $slider = $(this).find(".usplist-slider");
          $slider.slick("slickSetOption", "autoplay", true, true);

          const autoPlay = setInterval(function () {
            $slider.slick("slickNext");
          }, 1500);

          $(this).data("uspInterval", autoPlay);
        })
        .on("mouseleave", function () {
          const $slider = $(this).find(".usplist-slider");
          clearInterval($(this).data("uspInterval"));
          $slider.slick("slickGoTo", 0, true);
          $slider.slick("slickSetOption", "autoplay", false, true);
        });
    } else {
      $(".usplist-slider").slick("slickSetOption", "autoplaySpeed", 3000, true);
      $(".usplist-slider").slick("slickSetOption", "autoplay", true, true);
    }
  });

  // =========================
  // Know More / Show Less (coupons)
  // =========================
  on("click", ".knowmore", function () {
    const parent = this.closest(".coupons-inner");
    if (!parent) return;
    parent.classList.toggle("active");
    this.textContent = parent.classList.contains("active") ? "Show Less" : "Know More";
  });

  // =========================
  // Know More / Show Less (payment)
  // =========================
  on("click", ".knowmore-payment", function () {
    const parent = this.closest(".payemnt-inn");
    if (!parent) return;
    parent.classList.toggle("active");
    this.textContent = parent.classList.contains("active") ? "Show Less" : "Know More";
  });

  // =========================
  // Copy Coupon Code
  // =========================
  on("click", ".copucode-sec", function () {
    const el = this;

    document
      .querySelectorAll(".copucode-sec.active")
      .forEach(function (b) { b.classList.remove("active"); });

    el.classList.add("active");

    const couponsInner = el.closest(".coupons-inner");
    const txtEl = couponsInner
      ? couponsInner.querySelector(".coupons-txtmain")
      : null;
    const couponCode = txtEl ? txtEl.textContent.trim() : "";

    if (couponCode) navigator.clipboard.writeText(couponCode);

    setTimeout(function () {
      el.classList.remove("active");
    }, 2000);
  });

  // =========================
  // Offers tabs
  // =========================
  const couponsBtn = document.getElementById("coupons-btn");
  if (couponsBtn) {
    couponsBtn.addEventListener("click", function () {
      document
        .querySelectorAll(".buttonsection-offers button.active")
        .forEach(function (b) { b.classList.remove("active"); });
      this.classList.add("active");

      const couponsSec = document.querySelector(".coupons-sectionmain");
      const paymentSec = document.querySelector(".payment-offersection");
      if (couponsSec) couponsSec.style.display = "";
      if (paymentSec) paymentSec.style.display = "none";
    });
  }

  const paymentBtn = document.getElementById("payment-btn");
  if (paymentBtn) {
    paymentBtn.addEventListener("click", function () {
      document
        .querySelectorAll(".buttonsection-offers button.active")
        .forEach(function (b) { b.classList.remove("active"); });
      this.classList.add("active");

      const couponsSec = document.querySelector(".coupons-sectionmain");
      const paymentSec = document.querySelector(".payment-offersection");
      if (couponsSec) couponsSec.style.display = "none";
      if (paymentSec) paymentSec.style.display = "";
    });
  }

  on("click", ".offersection-activeoffers button", function () {
    const el = document.querySelector(".activeoffers-section");
    if (el) el.style.display = "";
  });

  on("click", ".closebtn-offer img", function () {
    const el = document.querySelector(".activeoffers-section");
    if (el) el.style.display = "none";
  });

  // =========================
  // Read more / Read less
  // =========================
  on("click", ".readmore-text", function () {
    const imgSection = document.querySelector(".customimage-section");
    const accordionInner = document.querySelector(".desktopsecton-accordioninner");

    if (imgSection) imgSection.classList.toggle("active");
    if (accordionInner) accordionInner.classList.toggle("active");

    this.textContent =
      imgSection && imgSection.classList.contains("active") ? "Read Less" : "Read More";
  });

  // =========================
  // FAQ view more / view less
  // =========================
  ready(function () {
    document.querySelectorAll(".faq").forEach(function (section) {
      const accordions = section.querySelectorAll(".product-details .accordion");
      const visibleItems = 5;
      const viewMoreBtn = section.querySelector(".viewmore-btn");

      if (accordions.length <= visibleItems) {
        if (viewMoreBtn) viewMoreBtn.style.display = "none";
        return;
      }

      const hiddenAccordions = Array.prototype.slice.call(accordions, visibleItems);
      hiddenAccordions.forEach(function (el) { el.style.display = "none"; });

      if (!viewMoreBtn) return;

      viewMoreBtn.addEventListener("click", function () {
        const span = viewMoreBtn.querySelector("span");
        const isActive = viewMoreBtn.classList.contains("active");

        hiddenAccordions.forEach(function (el) {
          el.style.display = isActive ? "none" : "";
        });

        viewMoreBtn.classList.toggle("active", !isActive);
        if (span) span.textContent = isActive ? "View All" : "View Less";
      });
    });
  });

  // =========================
  // Accordion heading toggle
  // =========================
  document.querySelectorAll(".accordion-headingsec").forEach(function (el) {
    el.addEventListener("click", function () {
      this.classList.toggle("active");
    });
  });
})();




$('.stickyslider-bar').on('init afterChange', function(event, slick) {
  $('.slick-slide').each(function() {
    const isHidden = $(this).attr('aria-hidden') === 'true';

    $(this)
      .find('a, button, input, select, textarea, [tabindex]')
      .attr('tabindex', isHidden ? '-1' : '0');
  });
});